/**
 * Shared endpoint configurations for reuse across nodes
 */

// Import audio plugin to ensure envelope type augmentation is in scope
import '@audio/audioPlugin';

/**
 * Standard ADSR envelope endpoints (input-only for synths)
 */
export const envelopeEndpoints = {
  envelope: { dataType: 'envelope', order: 1, isInput: true, group: 'envelope' },
  attack: { name: 'A', value: 0.01, min: 0.01, max: 1, step: 0.01, group: 'envelope' },
  decay: { name: 'D', value: 0.1, min: 0.01, max: 1, step: 0.01, group: 'envelope' },
  sustain: { name: 'S', value: 0.5, min: 0, max: 1, step: 0.01, group: 'envelope' },
  release: { name: 'R', value: 0.2, min: 0.01, max: 1, step: 0.01, group: 'envelope' },
} as const;

/**
 * Standard synth default endpoints (default pitch, length in ticks, velocity)
 */
export const synthDefaultEndpoints = {
  defaultPitch: { group: 'Default note', label: 'Pitch', value: 60, min: 0, max: 127, step: 1 },
  defaultLength: { group: 'Default note', label: 'Length', value: 24, options: [6, 12, 24, 48, 96] as const },
  defaultVelocity: { group: 'Default note', label: 'Velocity', value: 0.7, min: 0, max: 1, step: 0.01 },
} as const;

/**
 * Standard pattern generator endpoints (shared by all pattern generators)
 */
export const patternGeneratorEndpoints = {
  pattern: { dataType: 'array', isOutput: true },
} as const;
